import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, timer } from 'rxjs';
import { filter, mergeMap, repeat, takeWhile } from 'rxjs/operators';
import { SithsEIDService } from '../api';
import { PollResponse, StatusCode } from '../model';

@Injectable()
export class SithsEIDPollingService {
  private sithsEIDService = inject(SithsEIDService);

  private readonly INITIAL_DELAY = 1000;
  private readonly POLL_DELAY = 1000;

  private pollResponse: BehaviorSubject<PollResponse> = new BehaviorSubject<PollResponse>(null);

  private currentQrStartTokenCodeB64: string;

  public connect(id: string, sameDevice: boolean, idp: string): Observable<PollResponse> {
    timer(this.INITIAL_DELAY).subscribe(() => this.startPolling(id, sameDevice, idp));

    return this.pollResponse.asObservable();
  }

  private startPolling(id: string, sameDevice: boolean, idp: string): void {
    of({})
      .pipe(
        mergeMap(() => this.sithsEIDService.getStatus(id, sameDevice, this.currentQrStartTokenCodeB64, idp)),
        filter(pollResponse => pollResponse != null),
        takeWhile(pollResponse => pollResponse.statusCode === StatusCode.PENDING, true),
        repeat({ delay: this.POLL_DELAY })
      )
      .subscribe(result => {
        this.currentQrStartTokenCodeB64 = result.qrStartTokenCodeB64;

        this.pollResponse.next(result);
      });
  }
}
